"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddAdditionalSeatsPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var AddAdditionalSeatsPropsInterface = {
  merchandiseId: _propTypes.default.number,
  trackingSource: _propTypes.default.string
};
exports.AddAdditionalSeatsPropsInterface = AddAdditionalSeatsPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/additionalSeats/AddAdditionalSeatsPropsInterface.js
// module id = 774
// module chunks = 5 6